/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useContext } from 'react';
import useSWR from 'swr';
import { UseSWRMutationResult } from '../../common/types/swrTypes';
import { deleteToApi, getFromApi, postToApi, putToApi } from '../../common/utils/apiHelper';
import { ConfigContext } from '../configuration/ConfigContext';
import { usePropertyAssociationContext } from '../propertyAssociation/PropertyAssociationContext';
import { Admin } from './models/Admin';

type UsePropertyAssociationAdminsResult = UseSWRMutationResult<Admin[], 'admins'>;

export const usePropertyAssociationAdmins = (): UsePropertyAssociationAdminsResult => {
    const { apiBaseUrl } = useContext(ConfigContext);
    const { currentPropertyAssociationId } = usePropertyAssociationContext();

    const url = currentPropertyAssociationId ? `${apiBaseUrl}/propertyassociations/${currentPropertyAssociationId}/managers` : null;

    const { data, error, isLoading, mutate } = useSWR<Admin[]>(url);

    return {
        admins: data,
        isLoading,
        error,
        refetch: () => mutate(),
    };
};

export const getPropertyAssociationAdmins = (apiBaseUrl: string, propertyAssociationId: string, onSuccess: (data: Admin[]) => void, onFail: () => void): void => {
    getFromApi(`${apiBaseUrl}/propertyassociations/${propertyAssociationId}/managers`, onSuccess, onFail);
};

// Deprecated
export const addPropertyAssociationAdminGuest = (apiBaseUrl: string, propertyAssociationId: string, data: any, onSuccess: () => void, onFail: () => void): void => {
    postToApi(`${apiBaseUrl}/propertyassociations/${propertyAssociationId}/managers`, data, onSuccess, onFail);
};

export const removePropertyAssociationAdminGuest = (apiBaseUrl: string, propertyAssociationId: string, userId: string, onSuccess: () => void, onFail: () => void): void => {
    deleteToApi(`${apiBaseUrl}/propertyassociations/${propertyAssociationId}/managers/${userId}`, onSuccess, onFail);
};

export const updateAccessLevel = (apiBaseUrl: string, propertyAssociationId: string, userId: string, accessLevel: number, onSuccess: () => void, onFail: () => void): void => {
    putToApi(`${apiBaseUrl}/propertyassociations/${propertyAssociationId}/managers/${userId}/accesslevel/${accessLevel}`, {}, onSuccess, onFail);
};

export const updatePropertyAssociationAdmins = (apiBaseUrl: string, propertyAssociationId: string, onSuccess: () => void, onFail: () => void): void => {
    postToApi(`${apiBaseUrl}/propertyassociations/${propertyAssociationId}/managers/update`, undefined, onSuccess, onFail);
};
